import React, { useState, useEffect } from "react";
import MainLayout from "../../Layout/mainLayout";
import { ReactComponent as Franchise } from "../../Global Icons/Franchise.svg";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import TextInput from "../../Global Functions/textInput";
import TwoButtons from "../../Global Functions/buttons";
import {
  updateRewardPoints,
  viewRewardPoints,
} from "../../Redux/Actions/rewardsAction";
import { useNavigate, useParams } from "react-router-dom";

const UpdateRewardPoints = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  const [formState, setFormState] = useState({
    min_value: "",
    max_value: "",
    reward_points: "",
    id: "",
  });

  // Select pointDetails from Redux state
  const pointDetails = useSelector((state) => state.rewards.pointDetails);

  // On mount, fetch reward point details
  useEffect(() => {
    if (id) {
      dispatch(viewRewardPoints(id));
    }
  }, [dispatch, id]);

  // When pointDetails updates, populate form state
  useEffect(() => {
    if (pointDetails) {
      setFormState({
        min_value: pointDetails.min_value || "",
        max_value: pointDetails.max_value || "",
        reward_points: pointDetails.reward_points || "",
        id: pointDetails.id || id,
      });
    }
  }, [pointDetails, id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormState((prev) => ({ ...prev, [name]: value }));
  };

  const handleUpdate = async () => {
    if (
      formState.min_value === "" ||
      formState.max_value === "" ||
      formState.reward_points === ""
    ) {
      return toast.error("Please fill all required fields.");
    }
    if (Number(formState.min_value) >= Number(formState.max_value)) {
      return toast.error("Min value must be less than max value.");
    }
    const rewardPointsValue = Number(formState.reward_points);
    if (!Number.isInteger(rewardPointsValue) || rewardPointsValue <= 0) {
      return toast.error(
        "Reward Points must be a positive integer (no decimals, no zero)."
      );
    }

    const payload = {
      min_value: Number(formState.min_value),
      max_value: Number(formState.max_value),
      reward_points: Number(formState.reward_points),
      id: formState.id,
    };

    try {
      const response = await dispatch(updateRewardPoints(payload));
      if (
        response &&
        (response.statusCode === 200 || response.status === "success")
      ) {
        // toast.success("Reward points updated successfully!");
        navigate("/rewards");
      } else {
        toast.error(response.message || "Failed to update reward points");
      }
    } catch {
      toast.error("Error updating reward points");
    }
  };

  return (
    <MainLayout>
      <div className="franchise-form-container">
        <div className="franchise-form-wrapper franchise-card">
          <div className="franchise-card-content">
            <div className="franchise-header">
              <div className="franchise-header-icon">
                <Franchise />
              </div>
              <h1>Update Reward Points</h1>
            </div>

            <div className="form-section">
              <TextInput
                label="Minimum Value"
                name="min_value"
                type="number"
                value={formState.min_value}
                onChange={handleChange}
                required
                inputClass="form-input"
                labelClass="form-label"
              />
            </div>

            <div className="form-section">
              <TextInput
                label="Maximum Value"
                name="max_value"
                type="number"
                value={formState.max_value}
                onChange={handleChange}
                required
                inputClass="form-input"
                labelClass="form-label"
              />
            </div>

            <div className="form-section">
              <TextInput
                label="Reward Points"
                name="reward_points"
                type="text"
                value={formState.reward_points}
                onChange={handleChange}
                inputMode="numeric"
                pattern="^[1-9][0-9]*$"
                onInput={(e) => {
                  let val = e.target.value.replace(/[^0-9]/g, ""); // Remove non-digits
                  val = val.replace(/^0+/, ""); // Remove leading zeros
                  setFormState((prev) => ({ ...prev, reward_points: val }));
                }}
                required
                inputClass="form-input"
                labelClass="form-label"
              />
            </div>

            <div className="form-navigation">
              <button type="button" onClick={() => navigate("/rewards")}>
                Cancel
              </button>
              <TwoButtons onClick2={handleUpdate} buttonHead2="Update" />
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default UpdateRewardPoints;
